module.exports = __webpack_public_path__ + "static/media/envelope.6f40f855.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/envelope.svg
// module id = 2585
// module chunks = 0